import { axiosInstance, SEARCH_API } from "../apiurls/apiurls";

export const searchContent = async (courseKey, query) => {
  try {
    const response = await axiosInstance.get(
      `${SEARCH_API}?course_key=${courseKey}&search=${query}`
    );
    return response.data;
  } catch (error) {
    console.error("Error searching content:", error);
    throw error;
  }
};
